import React, { forwardRef } from 'react';
import { useForwardedRef } from '@anton.bobrov/react-hooks';
import { useNonMobileHover } from '@anton.bobrov/react-vevet-hooks';
import cx from 'classnames';
import { Background } from './compounds/Background/index.js';
import { Icon } from './compounds/Icon/index.js';
import styles from './index.module.scss.js';

const Base = forwardRef(
  ({
    className,
    style,
    type = "button",
    title,
    icon,
    size = "md",
    iconActive,
    hasIconDefaultTransparency = true,
    kind = "green",
    isActive = false,
    image,
    count,
    buttonType,
    ...props
  }, forwardedRef) => {
    const ref = useForwardedRef(forwardedRef);
    const isHovered = useNonMobileHover(ref);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        ref,
        className: cx(styles.box, className, {
          [styles[size || ""]]: !!size,
          [styles[buttonType || ""]]: !!buttonType,
          [styles[title.toLowerCase()]]: title,
          [styles["with-count"]]: count
        }),
        style,
        type,
        title,
        "aria-label": title
      },
      !image && /* @__PURE__ */ React.createElement(Background, { kind, isHovered, isActive }),
      !!count && /* @__PURE__ */ React.createElement("span", { className: styles.count, "aria-label": `${count} Notifications` }, count),
      image ? /* @__PURE__ */ React.createElement("img", { className: styles.image, src: image, alt: "button" }) : /* @__PURE__ */ React.createElement(
        Icon,
        {
          icon,
          iconActive,
          hasIconDefaultTransparency,
          isHovered,
          isActive,
          kind,
          className: styles["button-icon"]
        }
      )
    );
  }
);
Base.displayName = "BabyButton.Base";

export { Base };
//# sourceMappingURL=Base.js.map
